// import { isFuture, isPast } from 'date-fns'

import jwt_decode from 'jwt-decode'

import { commonDefaultAppConfig, refreshIntervalThreshold } from '../constants/common'
import { pathIds } from '../constants/paths'
import { isDevMode } from '../envs/envs'
import { ChannelType, EventType, HomeTab, OfferType } from '../types/servicesTypes/configTypes'
import { TabType } from '../types/servicesTypes/pageTypes'

// TODO as types already in the SDK, reuse these code directly, remove from the apps

// import { imageType } from '../constants/icons'
// import {
//   AccessRightsType,
//   ChannelType,
//   ConfigType,
//   ImageSourceType,
//   LineType,
//   TileType,
// } from '../types/servicesTypes/configTypes'
// import { FindImgByWidthOptionsType, GridBoxType } from '../types/utilsTypes'

/**
 * Removes all link tags from the given HTML string.
 *
 * @param {string} html - The HTML string to clean up.
 * @return {string} The cleaned up HTML string.
 */
export const htmlCleanup = (html: string) => {
  let res = html
  try {
    res = html.replace(/<a[^>]*>|<\/a>/g, '')
  } catch (error) {}
  return res
}

/**
 * The best suitable image width.
 * Used to find the nearest matching object in data images sources array
 */

// export const findNearestByImgWidth = (
//   data: Array<ImageSourceType> | undefined,
//   targetWidth: number = window.innerWidth,
//   options: FindImgByWidthOptionsType = {},
// ) => {
//   const { prioritizeSvg, targetAspectRatio } = options
//   if (!data || data.length === 0) {
//     return { format: '', width: 0, height: 0, url: '', darkTheme: false }
//   }
//
//   let res
//   let filteredData = data
//
//   if (prioritizeSvg) {
//     const svg = data.find((el) => el.format.toLowerCase() === imageType.VECTOR)
//     if (svg) return svg
//   }
//
//   if (targetAspectRatio) {
//     const [width, height] = targetAspectRatio.split('/').map(Number)
//     const aspectRatio = width && height && width / height
//     if (aspectRatio) {
//       filteredData = filteredData.filter((el) => (el.width / el.height).toFixed(1) === aspectRatio.toFixed(1))
//     }
//   }
//
//   if (filteredData.length) {
//     res = filteredData.reduce((acc, obj) =>
//       Math.abs(targetWidth - obj.width) < Math.abs(targetWidth - acc.width) ? obj : acc,
//     )
//   }
//
//   if (res && res.width > targetWidth * 3) {
//     const oversizeValue = (res.width / targetWidth).toFixed(1)
//     res = { ...res, oversize: `${oversizeValue}` }
//   }
//
//   /* return {
//     format: '',
//     width: 0,
//     height: 0,
//     url: `https://picsum.photos/${targetWidth}`,
//     // url: '',
//     darkTheme: false,
//   } */
//
//   return res
// }

export const getSecondsToDate = (date: Date) => {
  const now = new Date()
  const diff = date.getTime() - now.getTime()

  return Math.floor(diff / 1000)
}

/**
 *
 * @param start Date
 * @param end Date
 * @returns true if current date is between start and end dates
 */
// const isNowBetween = (start: Date, end: Date) => isPast(start) && isFuture(end)

// export const checkAccessRights = (userAccessRights: Nullable<AccessRightsType>, activeChannel: ChannelType): boolean => {
//   // Check if channel is watchable
//   if (!activeChannel.watchable) return false
//
//   // Check if channel is public
//   if (activeChannel.public && !userAccessRights?.customerBlocked) return true
//
//   // Check if user is blocked or has no access rights
//   if (userAccessRights?.customerBlocked || !userAccessRights?.items?.length) return false
//
//   // Check if user has access to current channel
//   return userAccessRights.items.some(
//     ({ blocked, accessRightUniqueId, lifeTimeStart, lifeTimeEnd, pauseTimeStart, pauseTimeEnd, itemType }) => {
//       if (blocked || !accessRightUniqueId) return false
//
//       // Check if user is in pause
//       if (pauseTimeStart && pauseTimeEnd) {
//         const isPause = isNowBetween(new Date(pauseTimeStart), new Date(pauseTimeEnd))
//
//         if (isPause) return false
//       }
//
//       let isValidSubscription
//
//       switch (itemType) {
//         case 'SINGLE_PRODUCT':
//           isValidSubscription =
//             lifeTimeStart && lifeTimeEnd && isNowBetween(new Date(lifeTimeStart), new Date(lifeTimeEnd))
//           break
//         case 'SUBSCRIPTION_ITEM':
//         case 'EXTERNAL':
//           isValidSubscription = !blocked
//           break
//
//         default:
//           break
//       }
//
//       if (!isValidSubscription) return false
//
//       // Check if user has access to current channel
//       return activeChannel?.accessRightIds?.includes(accessRightUniqueId)
//     },
//   )
// }

/**
 * Updates data in a specified time interval.
 *
 * @param {() => Promise<void>} fn - The function to be executed.
 * @param {Nullable<number | string>} refreshInterval - The interval at which the function should be executed. If null, the function does nothing. If the interval is less than or equal to `refreshIntervalThreshold`, it is set to `refreshIntervalThreshold`.
 * @return {() => void} A function that stops the interval when called.
 */
export const updateDataInTime = (fn: () => Promise<void>, refreshInterval: Nullable<number | string>): (() => void) => {
  if (refreshInterval === null) {
    return () => {}
  }
  if (Number(refreshInterval) <= refreshIntervalThreshold) {
    refreshInterval = refreshIntervalThreshold
  }
  let intervalId: ReturnType<typeof setInterval>

  if (typeof refreshInterval === 'number') {
    intervalId = setInterval(() => {
      fn()
    }, refreshInterval * 1000)
  } else {
    intervalId = setInterval(() => {
      fn()
    }, Number(commonDefaultAppConfig.refreshInterval) * 1000)
  }
  return () => clearInterval(intervalId)
}

/**
 * Returns the current Unix timestamp in seconds.
 *
 * @return {number} The current Unix timestamp in seconds.
 */
export const getUnixNowTime = () => {
  return Math.round(Date.now() / 1000)
}

export const isHex = (color: string) => {
  return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color)
}

/**
 * Converts a hexadecimal color code to its corresponding RGB values.
 *
 * @param {string} color - The hexadecimal color code (e.g., "#FF0000" for red).
 * @return {string} The RGB values of the color code, separated by commas (e.g., "255, 0, 0").
 * If the color parameter is falsy (e.g., undefined or null), an empty string is returned.
 */
export const hexToRgb = (color?: string) => {
  if (!color) {
    return ''
  }

  // Remove the '#' symbol
  const c = color.substring(1).split('')
  const expandedColor = c.length === 3 ? [c[0], c[0], c[1], c[1], c[2], c[2]] : c

  const r = parseInt(expandedColor[0] + expandedColor[1], 16)
  const g = parseInt(expandedColor[2] + expandedColor[3], 16)
  const b = parseInt(expandedColor[4] + expandedColor[5], 16)

  return `${r}, ${g}, ${b}`
}

export const hexToRgbA = (color: string) => {
  const rgb = hexToRgb(color)

  return `rgba(${rgb}, 1)`
}

export const getPageParams = (props?: { pageId?: string; tabs?: Partial<TabType>[]; homeTabs?: HomeTab[] }) => {
  const { pageId, tabs, homeTabs } = props || {}
  const pageParams = pageId || window.location.search
  const tabIndexRegEx = /tabIndex=(\d+)/
  const tabIdRegEx = /tabId=([^&]+)/
  const anchorIdRegEx = /anchorId=([^&]+)/
  const focusIdRegEx = /focusId=([^&]+)/
  const slideIndexRegEx = /slideIndex=(\d+)/
  const slideIdRegEx = /slideId=([^&]+)/

  const tabIndexUrlParam = Number(pageParams.match(tabIndexRegEx)?.[1])
  const isValidTabIndex = !isNaN(tabIndexUrlParam) && tabs && tabs.length > tabIndexUrlParam
  let tabIndex = isValidTabIndex ? tabIndexUrlParam : undefined
  if (tabIndex === undefined) {
    const tabId = pageParams.match(tabIdRegEx)?.[1]
    if (tabId && tabs) {
      const tabIndexByTabId = tabs.findIndex((tab) => tab.tabId === tabId)
      tabIndex = tabIndexByTabId >= 0 ? tabIndexByTabId : undefined
    }
  }

  let slideIndex
  if (homeTabs && tabIndex !== undefined) {
    const stageSlides = homeTabs[tabIndex]?.stageLinesPage?.stage?.slides

    const slideIndexUrlParam = Number(pageParams.match(slideIndexRegEx)?.[1])
    const isValidSlideIndex = !isNaN(slideIndexUrlParam) && stageSlides && stageSlides.length > slideIndexUrlParam
    slideIndex = isValidSlideIndex ? slideIndexUrlParam : undefined

    if (slideIndex === undefined) {
      const slideId = pageParams.match(slideIdRegEx)?.[1]
      if (slideId) {
        const slideIndexBySlideId = stageSlides?.findIndex((slide) => slide.id === slideId) ?? -1
        slideIndex = slideIndexBySlideId >= 0 ? slideIndexBySlideId : undefined
      }
    }
  }

  if (tabIndex === undefined && (homeTabs || tabs)) {
    tabIndex = 0
  }

  const anchorId = pageParams.match(anchorIdRegEx)?.[1]
  const focusId = pageParams.match(focusIdRegEx)?.[1]

  return { tabIndex, slideIndex, anchorId, focusId }
}

export const getUrlParam = (name: string) => {
  const match = window.location.search.match(new RegExp(`[?&]${name}=([^&]*)`))
  return match ? decodeURIComponent(match[1]) : null
}

export const isOlderVersion = (currentVersion: any, minVersion: any) => {
  const pattern = /^\d+\.\d+\.\d+$/
  if (!pattern.test(currentVersion) || !pattern.test(minVersion)) {
    return false
  }
  const currentParts = currentVersion.toString().split('.')
  const minParts = minVersion.toString().split('.')

  for (let i = 0; i < minParts.length; i++) {
    const c = parseInt(currentParts[i]) || 0
    const m = parseInt(minParts[i]) || 0
    if (c > m) {
      return false
    }
    if (c < m) {
      return true
    }
  }
  return false
}

/**
 * Decodes a JSON Web Token (JWT) into its corresponding object.
 *
 * @param {string} token - The JWT to be decoded.
 * @return {object} The decoded JWT as an object.
 */
export const decodeJwtToken = (token: string) => {
  const decoded = jwt_decode(token)
  return decoded
}

export const getPathByPageId = (pageId: string) => {
  for (const key in pathIds) {
    if (pathIds[key as keyof object] === pageId) {
      return key
    }
  }
}

/**
 * Sets up a localStorage listener that dispatches a storage event whenever an item is set in the localStorage.
 *
 * @return {void} This function does not return anything.
 */
export const setupLocalStorageListener = () => {
  const origSetItem = window.localStorage.setItem

  Storage.prototype.setItem = function customSetItem(key: string, value: string) {
    const result = origSetItem.apply(this, [key, value])

    const e = new StorageEvent('storage', {
      storageArea: window.localStorage,
      key,
      newValue: value,
      url: window.location.origin,
    })
    window.dispatchEvent(e)

    return result
  }
}

/**
 * Logs the fetch time information for a given API request.
 *
 * @param {string} name - The name of the API request.
 * @param {number} start - The start time of the API request.
 * @param {number} end - The end time of the API request.
 * @return {void} This function does not return anything.
 */
export const logFetchTimeInfo = (name: string, start: number, end: number) => {
  const fetchTiming = Math.round((end - start) / 10) * 10
  isDevMode && console.log(`${name} load time ${fetchTiming} ms`)
}

export const pickKeys = <T extends Record<string, any>, K extends keyof T>(
  sourceObject: T,
  keys: ReadonlyArray<K>,
): Pick<T, K> => {
  const newObj: Partial<Pick<T, K>> = {}

  for (const key of keys) {
    newObj[key] = sourceObject[key]
  }

  return newObj as Pick<T, K>
}

export const isHlsExtension = (url?: string): boolean => {
  if (!url) {
    return false
  }
  const HLS_EXTENSIONS = /\.(m3u8)($|\?)/i
  return HLS_EXTENSIONS.test(url)
}

export const isMp4Extension = (url?: string): boolean => {
  if (!url) {
    return false
  }
  const MP4_EXTENSIONS = /\.(mp4)($|\?)/i
  return MP4_EXTENSIONS.test(url)
}

export const capitalizeFirstLetter = (word?: string) => {
  if (typeof word !== 'string' || word.length === 0) {
    return ''
  }
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const getIsBought = (offer: OfferType) => {
  const canBuyMultiple = !!offer.id.startsWith('sw$sw-credits')
  const canAccess = !!offer.userRights?.canAccess
  if (canBuyMultiple) {
    return false
  }
  return canAccess
}

export const getContentAccessFlags = (
  event?: Nullable<EventType>,
  channel?: Nullable<ChannelType>,
  isRegisteredUser?: boolean,
) => {
  let isAccessible = false
  let isRequiresRegistrationOnly = false
  let isPPVEvent = false
  let isPremium = false

  if (event) {
    isRequiresRegistrationOnly = !!event.requiresRegistration
    const allowWatchWithoutSubscription = isRegisteredUser && isRequiresRegistrationOnly
    isAccessible = Boolean(allowWatchWithoutSubscription || event.userRights?.canAccess)
    isPPVEvent = !!event.ppvInfo && !isRequiresRegistrationOnly
    isPremium = !isRequiresRegistrationOnly && !event.public
  } else if (channel) {
    isRequiresRegistrationOnly = !!channel.requiresRegistration
    const allowWatchWithoutSubscription = isRegisteredUser && isRequiresRegistrationOnly
    isAccessible = Boolean(allowWatchWithoutSubscription || channel.userRights?.canAccess)
    isPremium = !isRequiresRegistrationOnly && !channel.public
  }

  return { isAccessible, isRequiresRegistrationOnly, isPPVEvent, isPremium }
}
